import { createSelector } from 'reselect';

import { getSheetState } from '../../mobile/structural/sheet/sheetSelectors';
import { getMilanoteApplicationModeSelector } from '../../platform/platformSelector';
import { getErrorModalSelector } from './modals/errorModalSelector';

import { ErrorSheetState, SheetId } from '../../mobile/structural/sheet/sheetTypes';
import { MilanoteApplicationMode } from '../../../common/platform/platformTypes';

export const getErrorSheetSelector = (state: any) => getSheetState(SheetId.Error)(state) as ErrorSheetState | undefined;

const getErrorNoticeSelector = createSelector(
    getMilanoteApplicationModeSelector,
    getErrorModalSelector,
    getErrorSheetSelector,
    (appMode, errorModal, errorSheet) => {
        if (appMode === MilanoteApplicationMode.mobile) return errorSheet;

        return errorModal;
    },
);

export const getActiveErrorNoticeId = createSelector(
    getErrorNoticeSelector,
    (errorNotice) => errorNotice?.activeErrorNoticeId,
);

export const getErrorNoticeData = createSelector(getErrorNoticeSelector, (errorNotice) => errorNotice?.data);
